import React from 'react';
import { makeStyles, Box, Theme, Typography } from '@material-ui/core';
import { ISectionItem } from './types';
import { QuestionItem } from './QuestionItem';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    questionsContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
}));

export const SectionItem = ({
    section,
    vehicle,
    handleChange,
    handleChangeVehicle,
    isEditable,
    ...props
}: ISectionItem) => {
    const classes = useStyles();

    return (
        <Box className={classes.root} {...props}>
            <Typography variant="h4" color="textPrimary">
                {section.title}
            </Typography>
            <Box className={classes.questionsContainer}>
                {section.questions.map((question, key) => (
                    <QuestionItem
                        question={question}
                        vehicle={vehicle}
                        handleChange={handleChange}
                        handleChangeVehicle={handleChangeVehicle}
                        isEditable={isEditable}
                        key={key}
                    />
                ))}
            </Box>

            {section.quotes?.map((quote, key) => (
                <Typography variant="body1" color="textPrimary" key={key}>
                    {quote}
                </Typography>
            ))}
        </Box>
    );
};
